import React from 'react';
import AppSidebar from '../../../../../../base/components/layout/app-sidebar';

const HeaderMenus = () => <AppSidebar />;

export default HeaderMenus;
